import { axiosInstance as axios } from "services";

export const createPromotionalCode = async (body) => {
  try {
    const { data } = await axios.post(`/admin/subscription/promotional-codes`, body);
    if (!data.success) throw new Error(data.error?.message || "Failed to create promotional code");
    return data;
  } catch (error) {
    if (error.response?.data?.error?.message) {
      throw new Error(error.response.data.error.message);
    }
    throw error;
  }
};

